require('./bootstrap');

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

window.bootstrap = require('bootstrap');

var moment = require('moment');

import 'slick-carousel'

import flatpickr from 'flatpickr';
window.flatpckr = flatpickr;
import '@nextapps-be/livewire-sortablejs';

import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';

$(document).on('click', '.page-link-scroll-to-top', function (e) {
 $('html, body').animate({
        scrollTop: $("#sort-by-block").offset().top
    }, 1000);
});

Livewire.on('scrollTop', () => {
	if($("#form-errors").length > 0)
	{
		var offset = $("#form-errors").offset().top
	    window.scrollTo({
	        top: offset,
	        left: 15,
	        behaviour: 'smooth'
	    })
	}
});

Livewire.on('menuAdded', () => {
    const menuModal = document.querySelector('#create-menu-modal');
    const modal = bootstrap.Modal.getInstance(menuModal);    
    modal.toggle();
});

Livewire.on('menuUpdated', () => {
    const menuModal = document.querySelector('#edit-menu-modal');
    const modal = bootstrap.Modal.getInstance(menuModal);    
    modal.toggle();
});

Livewire.on('menuDeleted', () => {
    const menuModal = document.querySelector('#delete-menu-modal');
    const modal = bootstrap.Modal.getInstance(menuModal);    
    modal.toggle();
});


Livewire.on('menuItemAdded', () => {
    const menuItemModal = document.querySelector('#create-menu-item-modal');
    const modal = bootstrap.Modal.getInstance(menuItemModal);    
    modal.toggle();
});


Livewire.on('menuItemUpdated', () => {
    const menuItemModal = document.querySelector('#edit-menu-item-modal');
    const modal = bootstrap.Modal.getInstance(menuItemModal);    
    modal.toggle();
});

Livewire.on('pageAdded', () => {
    const pageModal = document.querySelector('#create-page-modal');
    const modal = bootstrap.Modal.getInstance(pageModal);    
    modal.toggle();
});

Livewire.on('pageUpdated', () => {
    const pageModal = document.querySelector('#edit-page-modal');
    const modal = bootstrap.Modal.getInstance(pageModal);    
    modal.toggle();
});

Livewire.on('pageDeleted', () => {
    const pageModal = document.querySelector('#delete-page-modal');
    const modal = bootstrap.Modal.getInstance(pageModal);    
    modal.toggle();
});


Livewire.on('menuItemDeleted', () => {
    const menuItemModal = document.querySelector('#delete-menu-item-modal');
    const modal = bootstrap.Modal.getInstance(menuItemModal);    
    modal.toggle();
});

Livewire.on('sectionAdded', () => {
	var sectionModal = document.getElementById('create-page-section-modal')
	var modal = bootstrap.Modal.getInstance(sectionModal)
	modal.toggle();
});

Livewire.on('sectionUpdated', () => {
	var sectionModal = document.getElementById('edit-page-section-modal')
	var modal = bootstrap.Modal.getInstance(sectionModal)
	modal.toggle();
});

Livewire.on('sectionDeleted', () => {
	var sectionModal = document.getElementById('delete-page-section-modal')
	var modal = bootstrap.Modal.getInstance(sectionModal)
	modal.toggle();
});

Livewire.on('showCreatePanelModal', () => {
	
});

Livewire.on('panelAdded', () => {
	var panelModal = document.getElementById('create-page-panel-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('panelUpdated', () => {
	var panelModal = document.getElementById('edit-page-panel-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('panelDeleted', () => {
	var panelModal = document.getElementById('delete-page-panel-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});


Livewire.on('ctaAdded', () => {
	var panelModal = document.getElementById('create-cta-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('ctaUpdated', () => {
	var panelModal = document.getElementById('edit-cta-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('ctaDeleted', () => {
	var panelModal = document.getElementById('delete-cta-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('branchAdded', () => {
	var branchModal = document.getElementById('create-branch-modal')
	var modal = bootstrap.Modal.getInstance(branchModal)
	modal.toggle();
});

Livewire.on('branchUpdated', () => {
	var branchModal = document.getElementById('edit-branch-modal')
	var modal = bootstrap.Modal.getInstance(branchModal)
	modal.toggle();
});

Livewire.on('branchDeleted', () => {
	var branchModal = document.getElementById('delete-branch-modal')
	var modal = bootstrap.Modal.getInstance(branchModal)
	modal.toggle();
});

Livewire.on('eventDeleted', () => {
	var eventModal = document.getElementById('delete-event-modal')
	var modal = bootstrap.Modal.getInstance(eventModal)
	modal.toggle();
});

Livewire.on('locationAdded', () => {
	var locationModal = document.getElementById('create-location-modal')
	var modal = bootstrap.Modal.getInstance(locationModal)
	modal.toggle();
});

Livewire.on('locationUpdated', () => {
	var locationModal = document.getElementById('edit-location-modal')
	var modal = bootstrap.Modal.getInstance(locationModal)
	modal.toggle();
});

Livewire.on('locationDeleted', () => {
	var locationModal = document.getElementById('delete-location-modal')
	var modal = bootstrap.Modal.getInstance(locationModal)
	modal.toggle();
});


Livewire.on('testimonialAdded', () => {
	var panelModal = document.getElementById('create-testimonial-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('testimonialUpdated', () => {
	var panelModal = document.getElementById('edit-testimonial-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('testimonialDeleted', () => {
	var panelModal = document.getElementById('delete-testimonial-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('videoAdded', () => {
	var panelModal = document.getElementById('create-video-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('videoUpdated', () => {
	var panelModal = document.getElementById('edit-video-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('videoDeleted', () => {
	var panelModal = document.getElementById('delete-video-modal')
	var modal = bootstrap.Modal.getInstance(panelModal)
	modal.toggle();
});

Livewire.on('articleDeleted', () => {
    const newsModal = document.querySelector('#delete-article-modal');
    const modal = bootstrap.Modal.getInstance(newsModal);    
    modal.toggle();
});

Livewire.on('userDeleted', () => {
    const userModal = document.querySelector('#delete-user-modal');
    const modal = bootstrap.Modal.getInstance(userModal);    
    modal.toggle();
});

Livewire.on('brochureDeleted', () => {
    const brochureModal = document.querySelector('#delete-brochure-modal');
    const modal = bootstrap.Modal.getInstance(brochureModal);    
    modal.toggle();
});

Livewire.on('offerDeleted', () => {
    const offerModal = document.querySelector('#delete-offer-modal');
    const modal = bootstrap.Modal.getInstance(offerModal);    
    modal.toggle();
});

Livewire.on('popupDeleted', () => {
    const popupModal = document.querySelector('#delete-popup-modal');
    const modal = bootstrap.Modal.getInstance(popupModal);    
    modal.toggle();
});

Livewire.on('aliasAdded', () => {
	var aliasModal = document.getElementById('create-alias-modal')
	var modal = bootstrap.Modal.getInstance(aliasModal)
	modal.toggle();
});

Livewire.on('aliasUpdated', () => {
	var aliasModal = document.getElementById('edit-alias-modal')
	var modal = bootstrap.Modal.getInstance(aliasModal)
	modal.toggle();
});

Livewire.on('aliasDeleted', () => {
	var aliasModal = document.getElementById('delete-alias-modal')
	var modal = bootstrap.Modal.getInstance(aliasModal)
	modal.toggle();
});

Livewire.on('awningManufacturerAdded', () => {
	var awningManafacturerModal = document.getElementById('create-awning-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(awningManafacturerModal)
	modal.toggle();
});

Livewire.on('awningManufacturerUpdated', () => {
	var awningManafacturerModal = document.getElementById('edit-awning-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(awningManafacturerModal)
	modal.toggle();
});

Livewire.on('awningManufacturerDeleted', () => {
	var awningManafacturerModal = document.getElementById('delete-awning-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(awningManafacturerModal)
	modal.toggle();
});

Livewire.on('awningCategoryAdded', () => {
	var awningCategoryModal = document.getElementById('create-awning-category-modal')
	var modal = bootstrap.Modal.getInstance(awningCategoryModal)
	modal.toggle();
});

Livewire.on('awningCategoryUpdated', () => {
	var awningCategoryModal = document.getElementById('edit-awning-category-modal')
	var modal = bootstrap.Modal.getInstance(awningCategoryModal)
	modal.toggle();
});

Livewire.on('awningCategoryDeleted', () => {
	var awningCategoryModal = document.getElementById('delete-awning-category-modal')
	var modal = bootstrap.Modal.getInstance(awningCategoryModal)
	modal.toggle();
});

Livewire.on('awningAdded', () => {
	var awningModal = document.getElementById('create-awning-modal')
	var modal = bootstrap.Modal.getInstance(awningModal)
	modal.toggle();
});

Livewire.on('awningUpdated', () => {
	var awningModal = document.getElementById('edit-awning-modal')
	var modal = bootstrap.Modal.getInstance(awningModal)
	modal.toggle();
});

Livewire.on('awningDeleted', () => {
	var awningModal = document.getElementById('delete-awning-modal')
	var modal = bootstrap.Modal.getInstance(awningModal)
	modal.toggle();
});

Livewire.on('ManufacturerAdded', () => {
	var ManafacturerModal = document.getElementById('create-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(ManafacturerModal)
	modal.toggle();
});

Livewire.on('ManufacturerUpdated', () => {
	var ManafacturerModal = document.getElementById('edit-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(ManafacturerModal)
	modal.toggle();
});

Livewire.on('ManufacturerDeleted', () => {
	var ManafacturerModal = document.getElementById('delete-manufacturer-modal')
	var modal = bootstrap.Modal.getInstance(ManafacturerModal)
	modal.toggle();
});
Livewire.on('bannerSlideAdded', () => {
	var BannerModal = document.getElementById('create-banner-slide-modal')
	var modal = bootstrap.Modal.getInstance(BannerModal)
	modal.toggle();
});
Livewire.on('bannerSliderDeleted', () => {
	var BannerModal = document.getElementById('delete-banner-modal')
	var modal = bootstrap.Modal.getInstance(BannerModal)
	modal.toggle();
});
Livewire.on('bannerSlideDeleted', () => {
	var BannerModal = document.getElementById('delete-banner-slide-modal')
	var modal = bootstrap.Modal.getInstance(BannerModal)
	modal.toggle();
});
Livewire.on('bannerSlideUpdated', () => {
	var BannerModal = document.getElementById('edit-banner-slide-modal')
	var modal = bootstrap.Modal.getInstance(BannerModal)
	modal.toggle();
});

Livewire.on('videoCategoryAdded', () => {
	var videCategoryModal = document.getElementById('create-video-category-modal')
	var modal = bootstrap.Modal.getInstance(videCategoryModal)
	modal.toggle();
});

Livewire.on('videoCategoryUpdated', () => {
	var videCategoryModal = document.getElementById('edit-video-category-modal')
	var modal = bootstrap.Modal.getInstance(videCategoryModal)
	modal.toggle();
});

Livewire.on('videoCategoryDeleted', () => {
	var videCategoryModal = document.getElementById('delete-video-category-modal')
	var modal = bootstrap.Modal.getInstance(videCategoryModal)
	modal.toggle();
});

Livewire.on('assetAdded', () => {
	var assetModal = document.getElementById('create-asset-modal')
	var modal = bootstrap.Modal.getInstance(assetModal);
	modal.toggle();
});

Livewire.on('assetUpdated', () => {
	var assetModal = document.getElementById('edit-asset-modal')
	var modal = bootstrap.Modal.getInstance(assetModal);
	modal.toggle();
});

Livewire.on('assetDeleted', () => {
	var assetModal = document.getElementById('delete-asset-modal')
	var modal = bootstrap.Modal.getInstance(assetModal);
	modal.toggle();
});

Livewire.on('timelineEntryAdded', () => {
	var entryModal = document.getElementById('create-timeline-entry-modal')
	var modal = bootstrap.Modal.getInstance(entryModal);
	modal.toggle();
});

Livewire.on('timelineEntryUpdated', () => {
	var entryModal = document.getElementById('edit-timeline-entry-modal')
	var modal = bootstrap.Modal.getInstance(entryModal);
	modal.toggle();
});

Livewire.on('timelineEntryDeleted', () => {
	var entryModal = document.getElementById('delete-timeline-entry-modal')
	var modal = bootstrap.Modal.getInstance(entryModal);
	modal.toggle();
});

Livewire.on('clearWYSIWYGForm', content => {
	console.log('clearWYSIWYGForm');
	const domEditableElement = document.querySelector( '.ck-editor__editable' );
	if(domEditableElement)
	{
		const editorInstance = domEditableElement.ckeditorInstance;
		editorInstance.setData( '' );
	}

});
Livewire.on('setWYSIWYGField', content => {
	console.log('setWYSIWYGField');
	console.log(content);
	const domEditableElement = document.querySelector( '.ck-editor__editable' );
	if(domEditableElement)
	{
		const editorInstance = domEditableElement.ckeditorInstance;
		editorInstance.setData( content );
	}

});



if(document.getElementById('popup-modal'))
{
	var popupModal = new bootstrap.Modal(document.getElementById('popup-modal'), {keyboard: false, backdrop: 'static'});
	popupModal.show();
}


var splides = document.querySelectorAll('.splide-slider');
if (splides.length) {
    for(var i=0; i<splides.length; i++) {
        var splideElement = splides[i];
        var splideDefaultOptions = {
            type:       'loop',
            perPage:    4,
            perMove:    1,
            pagination: false,
            drag:       true,
            gap:        20,
            breakpoints: {
                640: {
                    perPage: 1,
                    pagination:  true,
		            arrows:      true,
                },
                1024: {
                    perPage: 3,
                },
            },
        }        
        var splide = new Splide( splideElement, splideDefaultOptions ); 

	    splide.on( 'mounted', function() {
	        // if fewer slides than provided in options, set option to the number of slides
	        if ( splide.length <= splide.options.perPage ) {
	            splide.options.perPage = splide.length;
	        }
	    });

        splide.mount();
    }
}

var manufacturerSplides = document.querySelectorAll('.splide-manufacturer');
if (manufacturerSplides.length) {
    for(var i=0; i<manufacturerSplides.length; i++) {
        var manufacturerElement = manufacturerSplides[i];
        var manufacturerSplideOptions = {
            type:       'loop',
            perPage:    3,
            perMove:    1,
            pagination: false,
            drag:       true,
            gap:        20,
            breakpoints: {
                576: {
                    perPage: 2,
                },
                768: {
                    perPage: 2,
                },
                992: {
                    perPage: 2,
                },
            },
        }        
        var manufacturer = new Splide( manufacturerElement, manufacturerSplideOptions ); 

	    manufacturer.on( 'mounted', function() {
	        // if fewer slides than provided in options, set option to the number of slides
	        if ( manufacturer.length <= manufacturer.options.perPage ) {
	            manufacturer.options.perPage = manufacturer.length;
	        }
	    });

        manufacturer.mount();
    }
}

var ctaSplides = document.querySelectorAll('.splide-cta');
if (ctaSplides.length) {
    for(var i=0; i<ctaSplides.length; i++) {
        var ctaElement = ctaSplides[i];
        var ctaSplideOptions = {
            type:       'loop',
            perPage:    4,
            perMove:    1,
            pagination:  false,
            arrows:      true,
            drag:       true,
            gap:        20,
            breakpoints: {
                500: {
                    perPage: 1,
		            pagination:  true,
		            arrows:      true,
                },                
                768: {
                    perPage: 2,
		            pagination:  true,
		            arrows:      true,
                },
                1000: {
                    perPage: 2,
                },
                1200: {
                    perPage: 3,
                },
            },
        }        
        var cta = new Splide( ctaElement, ctaSplideOptions ); 


	    cta.on( 'mounted', function() {
	        // if fewer slides than provided in options, set option to the number of slides
	        if ( cta.length <= cta.options.perPage ) {
	            cta.options.perPage = cta.length;
	        }
	    });

        cta.mount();
    }
}


var bannerSplides = document.querySelectorAll('.splide-banner');
if (bannerSplides.length) {
    for (var i=0; i<bannerSplides.length; i++) {
        var bannerSplide = bannerSplides[i];
        var bannerSplideDefaultOptions = {
            type:        'loop',
            perPage:     1,
            perMove:     1,
            heightRatio: 0.45,
            pagination:  false,
            arrows:      true,
            drag:        true,
            gap:         20,
            breakpoints: {
                768: {
                    perPage: 1,
		            pagination:  true,
		            arrows:      false,
                },
                992: {
                    height: 750,
                    pagination: false,
                    arrows: false,
                },
            },
        }        
        var banner = new Splide(bannerSplide, bannerSplideDefaultOptions); 

	    banner.on( 'mounted', function() {
	        // if fewer slides than provided in options, set option to the number of slides
	        if ( banner.length <= banner.options.perPage ) {
	            banner.options.perPage = banner.length;
	        }
	    });
        
        banner.mount();
    }
}

var stockSplides = document.querySelectorAll('.splide-stock');
if (stockSplides.length) {
    for(var i=0; i<stockSplides.length; i++) {
        var splideElement = stockSplides[i];
        var splideDefaultOptions = {
            type:       'loop',
            perPage:    1,
            perMove:    1,
            pagination: false,
            drag:       true,
            gap:        20,
        }        
        var splide = new Splide( splideElement, splideDefaultOptions ); 

	    splide.on( 'mounted', function() {
	        // if fewer slides than provided in options, set option to the number of slides
	        if ( splide.length <= splide.options.perPage ) {
	            splide.options.perPage = splide.length;
	        }
	    });

	    var splideThumb = new Splide(document.getElementById('splide-thumbnails'), {
            type:       'loop',
            direction: "ttb",
            perPage:    2,
            perMove:    1,
            drag:       true,
            arrows: true,

        }   );

	    

        splide.mount();
    }
}



document.addEventListener("DOMContentLoaded", () => {
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	  return new bootstrap.Tooltip(tooltipTriggerEl)
	})

    Livewire.hook('message.processed', (message, component) => {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		  return new bootstrap.Tooltip(tooltipTriggerEl)
		})
    })
});

/*
var desktop_menu = document.getElementById('desktop_menu');
if(desktop_menu)
{
	desktop_menu.addEventListener('show.bs.collapse', function () {
		$('#navbar').addClass('desktop-menu-show');
	})
	desktop_menu.addEventListener('hidden.bs.collapse', function () {
		$('#navbar').removeClass('desktop-menu-show');
	})
}
*/

$('.desktop-menu').each(function(i, elm) {

	elm.addEventListener('hide.bs.collapse', function () {
		$('#navbar').removeClass('desktop-menu-show');
	})

	elm.addEventListener('shown.bs.collapse', function () {
		$('#navbar').addClass('desktop-menu-show');
	})

});



var mobile_menu = document.getElementById('mobile_menu');
if(mobile_menu)
{
	mobile_menu.addEventListener('show.bs.collapse', function () {
		$('body').addClass('position-fixed');
	})
	mobile_menu.addEventListener('hidden.bs.collapse', function () {
		$('body').removeClass('position-fixed');
	})
}

$( "#reset-motorhome-search-form" ).click(function(e) 
{
	e.preventDefault();
	document.getElementById('motorhome-search-form').reset();
});

$( "#reset-caravan-search-form" ).click(function(e) 
{
	e.preventDefault();
	document.getElementById('caravan-search-form').reset();
});
$( "#apply-mobile-motorhome-filters" ).click(function(e) 
{
	e.preventDefault();
	document.getElementById('motorhome-search-form').submit();
});

$( "#apply-mobile-caravan-filters" ).click(function(e) 
{
	e.preventDefault();
	document.getElementById('caravan-search-form').submit();
});

		 $('.stock-main-slider').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: true,
		  fade: true,
		  adaptiveHeight: true,
		  asNavFor: '.stock-nav-slider'
		});
		$('.stock-nav-slider').slick({
		  slidesToShow: 2,
		  arrows: false,
		  initialSlide: 1,
		  slidesToScroll: 1,
		  asNavFor: '.stock-main-slider',
		  dots: false,
		  centerMode: false,
		  focusOnSelect: true,
		  vertical: true,
		  verticalSwiping: true,
		  adaptiveHeight: true,
		});

// Disable scrolling on the maps unless the user clicks
$( document ).ready(function() {
    $('.map-panel > div').addClass('scrolloff');
    $('.map-panel').on('click', function() {
        $('.map-panel > div').removeClass('scrolloff');
    });

    $('.map-panel').mouseleave(function() {
        $('.map-panel > div').addClass('scrolloff');
    });
});

var videoModal = document.getElementById('show-video-modal')
videoModal.addEventListener('hidden.bs.modal', function (event) {
  document.getElementById('video-frame').src = '';
})




